document.querySelectorAll('.js-nav-closer').forEach((closer) => {
  closer.addEventListener('click', (e) => {
    const widget = e.currentTarget.closest('.dropdown')
    if (widget) {
      widget.classList.remove('is-open')
    }
  })
})
